define([
    "./temperatureModule",
    "./temperatureRouter",
    "./MonitoringTemperatureController",
    "../query/monitoringQuery"
], function () {
});